export var AccordeonDefaultProps = {
    as: 'section',
    titreAs: 'h2',
};
export var GroupeAccordeonsDefaultProps = {
    children: undefined,
    as: 'div',
};
